/*
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class PoweredByAPI
 * @hideconstructor
 * @classdesc API class that is used for PoweredBy
 */
define(() => {
	class PoweredByAPI {
		/**
		 * @function PoweredByAPI#get
		 * @description gets the current poweredBy object
		 * @example {
		 * 	widgetId1: ['db2', 'watson']
		 * }
		 * @param {string}[id] - id of the content (optional)
		 * @return  {object} - the current poweredBy object. If an id is passed, poweredBy[id] is returned
		 */
		get() {}

		/**
		 * @function PoweredByAPI#set
		 * @description set a PoweredBy with id, and a list of technology keys
		 * @param id - The id of content
		 * @param {string[]} - A list of technology keys
		 * @return  null
		 */
		set(){}
	}
	return PoweredByAPI;
});
